// extracted by mini-css-extract-plugin
export default {"payment-balance":"payment-balance--Ua371","paymentBalance":"payment-balance--Ua371"};